import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useStyles } from './TableMessage.styles';
export const TableMessage = (props) => {
    const classes = useStyles();
    return (React.createElement(Box, { component: "div", sx: classes.root },
        React.createElement(Box, { component: "div", sx: classes.icon }, props.icon),
        React.createElement(Typography, null, props.text)));
};
export default TableMessage;
